module.exports = __webpack_public_path__ + "static/media/anobis-logo.7a9b9c5a.svg";